import { FC, useState } from 'react'

import useFollowUpListagem from '@hook/followUpFornecedor/use-listagem'

import LayoutToolsButton from '../../Components/Button'

const ActionFollowUpFornecedorExport: FC = () => {
  const { exportarListagem } = useFollowUpListagem()
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    setIsLoading(true)
    try {
      await exportarListagem()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <LayoutToolsButton
      label="Exportar CSV"
      isLoading={isLoading}
      loadingText="Exportando..."
      onClick={handleClick}
    />
  )
}

export default ActionFollowUpFornecedorExport
